<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="line-scale-pulse-out">
<br>
    <p style="font-size: 20px; color: white">{{ loadingText }}</p>
</ngx-spinner>